var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8b62d;}.cls-2{fill:#231815;}.cls-3{font-size:161.72px;fill:#fff;stroke:#231815;stroke-miterlimit:10;font-family:DINAlternate-Bold, DIN Alternate;font-weight:700;}.cls-4{letter-spacing:-0.02em;}.cls-5{letter-spacing:-0.07em;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u56FE\\u5C42 1",
    id: "\\u56FE\\u5C42_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250,
    cy: 250,
    r: 84.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.3,250c-.26,31.93-20.27,61.69-50.61,72.59a78.28,78.28,0,0,1-86.62-23.7c-20.52-24.83-22.88-61.14-6.38-88.66s49.76-42.55,81.4-36.08A78.17,78.17,0,0,1,327.3,250c.08,9.65,15.08,9.67,15,0a93.46,93.46,0,0,0-61-86.83c-36.08-13.29-78.52-1.52-102.67,28.34s-27.79,72.65-7.9,105.83c20,33.39,59.57,50.62,97.68,43.11C311.16,332,342,293.16,342.3,250,342.38,240.35,327.38,240.34,327.3,250Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.5,131.39v-32c0-9.65-15-9.67-15,0v32c0,9.65,15,9.67,15,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 190.69,
    x2: 174.71,
    y1: 147.28,
    y2: 119.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.17,143.49l-16-27.69c-4.83-8.36-17.79-.81-13,7.57l16,27.69c4.83,8.36,17.79.81,13-7.57Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 147.28,
    x2: 119.59,
    y1: 190.69,
    y2: 174.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.06,184.22l-27.69-16c-8.38-4.84-15.94,8.12-7.57,13l27.69,16c8.38,4.84,15.94-8.12,7.57-13Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.39,
    x2: 99.42,
    y1: 250,
    y2: 250
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.39,242.5h-32c-9.65,0-9.67,15,0,15h32c9.65,0,9.67-15,0-15Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 147.28,
    x2: 119.59,
    y1: 309.31,
    y2: 325.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.49,302.83l-27.69,16c-8.36,4.83-.81,17.79,7.57,13l27.69-16c8.36-4.83.81-17.79-7.57-13Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 190.69,
    x2: 174.71,
    y1: 352.72,
    y2: 380.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.22,348.94l-16,27.69c-4.84,8.38,8.12,15.94,13,7.57l16-27.69c4.84-8.38-8.12-15.94-13-7.57Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 250,
    x2: 250,
    y1: 368.61,
    y2: 400.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.5,368.61v32c0,9.65,15,9.67,15,0v-32c0-9.65-15-9.67-15,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 309.31,
    x2: 325.29,
    y1: 352.72,
    y2: 380.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.83,356.51l16,27.69c4.83,8.36,17.79.81,13-7.57l-16-27.69c-4.83-8.36-17.79-.81-13,7.57Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 352.72,
    x2: 380.41,
    y1: 309.31,
    y2: 325.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.94,315.78l27.69,16c8.38,4.84,15.94-8.12,7.57-13l-27.69-16c-8.38-4.84-15.94,8.12-7.57,13Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 368.61,
    x2: 400.58,
    y1: 250,
    y2: 250
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.61,257.5h32c9.65,0,9.67-15,0-15h-32c-9.65,0-9.67,15,0,15Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 352.72,
    x2: 380.41,
    y1: 190.69,
    y2: 174.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.51,197.17l27.69-16c8.36-4.83.81-17.79-7.57-13l-27.69,16c-8.36,4.83-.81,17.79,7.57,13Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 309.31,
    x2: 325.29,
    y1: 147.28,
    y2: 119.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.78,151.06l16-27.69c4.84-8.38-8.12-15.94-13-7.57l-16,27.69c-4.84,8.38,8.12,15.94,13,7.57Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(-3.4 -30.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 98.94,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 185.56,
    y: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.79682a3039aeffb721a711687f9b54bd.svg";
export { ForwardRef as ReactComponent };